const initialState = {
  anuncioInicial: null,
  bodegas: [],
  buque: null,
  consultaBuque: null,
  detalleBodegas: [],
  detalleInicial: null,
  giros: [],
  estados: [],
  planDeEmbarque: [],
  requestingConsultaBuque: false,
  requestingGiros: false,
  receiveDetalleInicial: false,
  detalleCarga: null,
  actualizacionAnuncios: true,
  cargasAnunciadas: [],
  cargasAnunciadasCereales: [],
  cerealFiltro: 'TODOS',
  fechaCargaFiltro: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_CONSULTA_BUQUE':
      return {
        ...state,
        requestingConsultaBuque: true,
        consultaBuque: null
      }
    case 'RECEIVE_CONSULTA_BUQUE':
      return {
        ...state,
        requestingConsultaBuque: false,
        consultaBuque: action.consultaBuque
      }
    case 'REQUEST_GIROS':
      return {
        ...state,
        requestingGiros: true,
        giros: null
      }
    case 'RECEIVE_GIROS':
      return {
        ...state,
        requestingGiros: false,
        giros: action.giros
      }
    case 'REQUEST_ESTADOS':
      return {
        ...state,
        requestingEstados: true,
        estados: null
      }
    case 'RECEIVE_ESTADOS':
      return {
        ...state,
        requestingEstados: false,
        estados: action.estados
      }
    case 'RECEIVE_ANUNCIO_BUQUE':
      return {
        ...state,
        anuncioInicial: action.anuncio
      }
    case 'RESET_ANUNCIO_BUQUE':
      return {
        ...state,
        anuncioInicial: null
      }
    case 'REQUEST_PLAN_DE_EMBARQUE':
      return {
        ...state,
        planDeEmbarque: []
      }
    case 'RECEIVE_PLAN_DE_EMBARQUE':
      return {
        ...state,
        planDeEmbarque: action.data
      }
    case 'RECEIVE_PLAN_DE_EMBARQUE_BODEGA':
      return {
        ...state,
        detalleBodegas: action.d
      }
    case 'REQUEST_BODEGAS_BUQUE':
      return {
        ...state,
        isRequestingBodegas: true,
        bodegas: []
      }
    case 'RECEIVE_BODEGAS_BUQUE':
      return {
        ...state,
        isRequestingBodegas: false,
        bodegas: action.data
      }
    case 'RECEIVE_DETALLE_BODEGA':
      return {
        ...state,
        receiveDetalleInicial: true,
        detalleInicial: action.data
      }
    case 'CLOSE_EDICION_DETALLE_BODEGA':
      return {
        ...state,
        receiveDetalleInicial: false,
        detalleInicial: null
      }
    case 'RECEIVE_DETALLE_CARGA':
      return {
        ...state,
        detalleCarga: action.data
      }
    case 'RESET_DETALLE_CARGA':
      return {
        ...state,
        detalleCarga: null
      }
    case 'RECEIVE_CARGAS_BUQUE':
      return {
        ...state,
        cargasAnunciadas: action.data,
        cargasAnunciadasCereales: action.cereales
      }
    case 'ACTUALIZAR_CEREAL_FILTRO':
      return {
        ...state,
        cerealFiltro: action.cereal
      }
    case 'ACTUALIZAR_FECHA_CARGA_FILTRO':
      return {
        ...state,
        fechaCargaFiltro: action.fecha
      }
    case 'ACTUALIZACION_COMPLETA':
      return {
        ...state,
        actualizacionAnuncios: action.newValue
      }
    default:
      return state
  }
}
